export default __webpack_public_path__ + "static/media/images.png?.ec6f94be";